import PropTypes from 'prop-types';
import { Modal } from '@/ui';
import NuevaDiligenciaForm from './NuevaDiligenciaForm';

// Creation/edit surface for a diligencia: the shared NuevaDiligenciaForm in the
// shared Modal shell. The form owns its own action row; the page owns the
// mutation (create / edit) and closes on success.
export default function NuevaDiligenciaModal({
  open,
  onClose,
  mode = 'create',
  lockedCase,
  initial,
  onSubmit,
  apiError,
  isSubmitting,
}) {
  return (
    <Modal open={open} onClose={onClose} size="default">
      <Modal.Header
        title={mode === 'edit' ? 'Editar diligencia' : 'Nueva diligencia'}
        onClose={onClose}
      />
      <Modal.Body>
        <NuevaDiligenciaForm
          mode={mode}
          lockedCase={lockedCase}
          initial={initial}
          onSubmit={onSubmit}
          onCancel={onClose}
          apiError={apiError}
          isSubmitting={isSubmitting}
        />
      </Modal.Body>
    </Modal>
  );
}

NuevaDiligenciaModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['create', 'edit']),
  lockedCase: PropTypes.object,
  initial: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  apiError: PropTypes.string,
  isSubmitting: PropTypes.bool,
};
